import React from "react";
import { useSelector } from "react-redux";
import { ImSpinner5 } from "react-icons/im";
import {
  currentOrder,
  createOrderStatus
} from "../../features/order/orderSlice";
import "./Confirmation.css";
import { Grid, Row, Col } from "rsuite";
import Footer from "../Footer/Footer";

/**
 * Component that displays the confirmation page
 *
 * @return {JSX.Element} Confirmation component JSX
 */
export default function Confirmation() {
  const order = useSelector(currentOrder);
  const orderStatus = order.status ?? null;
  const statusCurrentOrder = useSelector(createOrderStatus);

  const renderLoader = (text) => (
    <div>
      <span className="spinner-text">{text}</span>
      <div className="spinner-container">
        <ImSpinner5 className="spinner" />
      </div>
    </div>
  );

  const renderOrderDetails = () => (
    <Grid fluid>
      <Row className="show-grid">
        <Col xs={24} sm={24} md={12} className="confirmation-col">
          <b>Thank you for your order!</b>
          We&apos;re excited to deliver the freshest and tastiest fruits and
          vegetables straight to your door. Your order has been confirmed and
          will be processed shortly. We&apos;ll keep you updated on its status
          every step of the way. If you have any questions or concerns, please
          don&apos;t hesitate to reach out to us.
          <p>Thanks again for choosing our fresh produce!</p>
          <br />
        </Col>
        <Col xs={24} sm={24} md={12} className="confirmation-col">
          <b>Order Details</b>
          <p>Total order value: {order.totalAmount}</p>
          <p>
            Shipping charge: {order.shipping_charge ? order.shipping_charge : 0}
          </p>
          <p>Total: {order.finalAmount}</p>
          {order.address ? (
            <p>
              <b>Delivery Address</b>
              <p className="delivery-address">
                <span>{order.address.name}</span>
                <span>{order.address.apartmentName}</span>
                <span>{order.address.flatNo}</span>
                <span>{order.address.addressLine1}</span>
                <span>{order.address.addressLine2}</span>
                <span>
                  {order.address.city}, {order.address.state},{" "}
                  {order.address.pinCode}
                </span>
              </p>
            </p>
          ) : (
            <p></p>
          )}
        </Col>
      </Row>
    </Grid>
  );

  return (
    <>
      <div className="confirmation-container">
        {statusCurrentOrder === "pending" ? (
          renderLoader("Please wait while we create your order")
        ) : statusCurrentOrder === "idle" ? (
          orderStatus === null ? (
            renderLoader("Please wait while we create your order")
          ) : orderStatus === "PENDING" ? (
            renderOrderDetails()
          ) : orderStatus === "FAILED" ? (
            <span className="spinner-text">
              There was an error processing your order, Please try again later.
            </span>
          ) : null
        ) : (
          renderOrderDetails()
        )}
      </div>
      <Footer tab={"products"} />
    </>
  );
}
